import { render, staticRenderFns } from "./main-table.vue?vue&type=template&id=57fb4c7a&"
import script from "./main-table.vue?vue&type=script&lang=js&"
export * from "./main-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports